import { render, staticRenderFns } from "./AuftragStornierenModal.vue?vue&type=template&id=2b1dac7a&"
import script from "./AuftragStornierenModal.vue?vue&type=script&lang=js&"
export * from "./AuftragStornierenModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports